module.exports = __webpack_public_path__ + "static/media/icon_top_up.d51a04f5.png";